<template lang="pug">
div.collapsible-list.emphasisSection.emphasisSection--row
  div.collapsible-list__title
    slot(name="title")
      p
        strong {{ title }}
  VExpansionPanels(
    v-model="openedPanels"
    :multiple="true"
  )
    slot
</template>

<script setup lang="ts">
import { ref } from "vue";

interface Props {
  title?: string;
}

const props = withDefaults(defineProps<Props>(), {
  title: "",
});

const openedPanels = ref<string[]>([]);
</script>
